import { z } from "zod";

export const eventEnvelopeSchema = z.object({
  eventId: z.uuid(),
  eventType: z.string().min(3),
  version: z.literal(1),
  occurredAt: z.iso.datetime(),
  organizationId: z.uuid(),
  aggregateType: z.string().min(1),
  aggregateId: z.uuid(),
  correlationId: z.uuid(),
  causationId: z.uuid().optional(),
  source: z.enum(["PLATFORM", "EVA", "PAGLOG", "MOBIMEDICAL", "SIGNATURE"]),
  payload: z.record(z.string(), z.unknown()),
});

export type EventEnvelope = z.infer<typeof eventEnvelopeSchema>;

export const SALES_EVENT_TYPES = [
  "sales.intent.received.v1",
  "sales.proposal.generated.v1",
  "contract.signed.v1",
  "billing.charge.created.v1",
  "billing.payment.confirmed.v1",
  "funeral.subscription.activated.v1",
  "telemedicine.beneficiary.provisioned.v1",
  "subscription.overdue.v1",
  "subscription.cancelled.v1",
  "commission.eligible.v1",
] as const;

export function createEvent(
  input: Omit<EventEnvelope, "version" | "occurredAt"> & { occurredAt?: string },
): EventEnvelope {
  return eventEnvelopeSchema.parse({
    ...input,
    version: 1,
    occurredAt: input.occurredAt ?? new Date().toISOString(),
  });
}
